import script from "./ProjectRejectedLifecycleSetter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectRejectedLifecycleSetter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__